export default "__VITE_ASSET__lNsKWpCV__"